<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" >添加产品</el-button>

      </el-col>
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="delBathGoods" style="width: 100%" >批量刪除</el-button>

      </el-col>
    </el-row>


    <el-table :data="tagsList" :height="wheight-130" v-loading="loading" @selection-change="handleSelectionChange" :row-key="getRowKeys">
      <el-table-column type="selection" :reserve-selection="true" v-model="checked" align="center" label="全选"></el-table-column>
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="name" label="商品名称" width="200" >
        <template slot-scope="scope">
          {{scope.row.name}}
      </template>
      </el-table-column>
      <el-table-column prop="type" label="商品类型" width="100">
        <template slot-scope="scope">
         <span v-if="scope.row.type=='1'">现金</span>
          <span v-if="scope.row.type=='2'">优惠券</span>
          <span v-if="scope.row.type=='3'">实物</span>
          <span v-if="scope.row.type=='4'">积分大转盘</span>
        </template>

      </el-table-column>
<!--      <el-table-column prop="is_online" label="优惠券类型" width="200">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.is_online=='1'">线上优惠券</span>-->
<!--          <span v-if="scope.row.is_online=='2'">线下优惠券</span>-->

<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="points" label="积分价格" width="100">
        <template slot-scope="scope">
          {{scope.row.points}}
        </template>
      </el-table-column>

      <el-table-column prop="card_id" label="卡券ID/策略ID" width="100">
        <template slot-scope="scope">
          {{scope.row.card_id}}
        </template>
      </el-table-column>
      <el-table-column prop="material_goods_id" label="实物ID" width="100">
        <template slot-scope="scope">
          {{scope.row.material_goods_id}}
        </template>
      </el-table-column>
      <el-table-column prop="pics" label="商品图片" width="200">
        <template slot-scope="scope">
<!--          {{scope.row.pics}}-->
          <el-image  :src="scope.row.pics" style="width: 100px;height: 60px" mode="modeWidth"></el-image>
        </template>
      </el-table-column>

      <el-table-column prop="time" label="创建时间" width="200">
        <template slot-scope="scope">
      {{scope.row.create_time}}
        </template>
      </el-table-column>

<!--      <el-table-column prop="intro" label="商品详情" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.intro}}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="is_pay" label="是否在售" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.is_pay=='1'">在售</span>
          <span v-if="scope.row.is_pay=='2'">不在售</span>
<!--          {{scope.row.is_pay}}-->
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>
<!--            <el-button type="text" @click="onSale(scope.$index, scope.row)">上架</el-button>-->
<!--            <el-button type="text" @click="onSale(scope.$index, scope.row)" >下架</el-button>-->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
     <el-pagination
     layout="prev, pager, next"
     @current-change="handleCurrentChange"
     :current-page.sync="params.page"
     :total="total_count" :page-size="params.pageSize">
     </el-pagination>
   </div>
   <el-dialog title="添加、编辑标签" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog" >
     <template>
       <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
         <el-form-item class="content-left" label="商品名称">
           <el-input placeholder="请输入商品名称" v-model="form.name"></el-input>
         </el-form-item>

         <el-form-item class="content-left" label="商品积分">
           <el-input placeholder="请输入商品积分值" v-model="form.points"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="兑换次数">
           <el-input placeholder="请输入商品兑换次数,无数填0" v-model="form.exchange_count"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="每天允许兑换最大次数">
           <el-input placeholder="请输入每天允许兑换最大次数,无数填0" v-model="form.max_day_exchange_count"></el-input>
         </el-form-item>
<!--         <el-form-item class="content-left" label="商品积分">-->

<!--           <el-input placeholder="请输入商品积分址" v-model="form.type"></el-input>-->
<!--         </el-form-item>-->
         <el-form-item class="content-left" label="商品类型">
           <template>
             <el-radio-group v-model="form.type" @change="type_change">
             <el-radio-button  label="1">现金</el-radio-button>
             <el-radio-button  label="2">优惠券</el-radio-button>
             <el-radio-button  label="3">实物</el-radio-button>
             </el-radio-group>
           </template>

         </el-form-item>
         <el-form-item class="content-left" label="商品详细分类">
           <template >
             <template>
               <el-select v-model="form.category_id" placeholder="请选择" multiple >
                 <el-option
                   v-for="item in cateGoryList"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
               </el-select>
             </template>
           </template>

         </el-form-item>
         <el-form-item class="content-left" label="是否置顶">
           <template>
             <el-radio-group v-model="form.top" @change="type_top_change">
               <el-radio-button  label="1">置顶</el-radio-button>
               <el-radio-button  label="0">不置顶</el-radio-button>

             </el-radio-group>
           </template>

         </el-form-item>
<!--         <el-form-item class="content-left" label="商品类型" v-if="form.type==2">-->
<!--           <template>-->
<!--             <el-radio-group v-model="form.detail_type">-->
<!--               <el-radio-button  label="1">现金</el-radio-button>-->
<!--               <el-radio-button  label="2">优惠券</el-radio-button>-->
<!--               <el-radio-button  label="3">实物</el-radio-button>-->
<!--             </el-radio-group>-->
<!--           </template>-->

<!--         </el-form-item>-->
<!--         <el-form-item class="content-left" label="商品类型" v-if="form.type==3">-->
<!--           <template>-->
<!--             <el-radio-group v-model="form.detail_type">-->
<!--               <el-radio-button  label="1">现金</el-radio-button>-->
<!--               <el-radio-button  label="2">优惠券</el-radio-button>-->
<!--               <el-radio-button  label="3">实物</el-radio-button>-->
<!--             </el-radio-group>-->
<!--           </template>-->

<!--         </el-form-item>-->

         <el-form-item class="content-left" label="卡券ID/策略ID">

           <el-input placeholder="仅限优惠券可填" v-model="form.card_id"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="线上线下">
           <template>
             <el-radio-group v-model="form.is_online">
               <el-radio-button  label="1">线上</el-radio-button>
               <el-radio-button  label="2">线下</el-radio-button>
             </el-radio-group>
           </template>
         </el-form-item>
         <el-form-item class="content-left" label="商品ID">

           <el-input placeholder="仅限实物可填" v-model="form.material_goods_id"></el-input>
         </el-form-item>


         <el-form-item class="content-left" label="是否在售">
           <template>
             <el-radio-group v-model="form.is_pay">
               <el-radio-button  label="1">在售</el-radio-button>
               <el-radio-button  label="2">不在售</el-radio-button>
             </el-radio-group>

           </template>
         </el-form-item>
         <el-form-item class="content-left" label="门店编码">
           <el-input
             type="textarea"
             :rows="2"
             placeholder="请输入门店ID，注意格式，门店之间用英文状态下的逗号“,”隔开"
             v-model="form.distribution_ids">
           </el-input>
         </el-form-item>
         <el-form-item class="content-left" label="兑换次数说明">
           <el-input
             type="textarea"
             :rows="2"
             placeholder="请输入内容"
             v-model="form.point_frequency">
           </el-input>
         </el-form-item>
         <el-form-item class="content-left" label="兑换须知">
           <el-input
             type="textarea"
             :rows="2"
             placeholder="请输入内容"
             v-model="form.exchange_instructions">
           </el-input>
         </el-form-item>
         <el-form-item class="content-left" label="商品详情">
           <el-input
             type="textarea"
             :rows="2"
             placeholder="请输入内容"
             v-model="form.intro">
           </el-input>
         </el-form-item>

<!--         <el-form-item class="content-left" label="图片地址">-->

<!--           <el-input placeholder="请输入图片地址" v-model="form.pics"></el-input>-->
<!--         </el-form-item>-->

         <el-upload
           class="upload-demo"
           :multiple="true"
           :action="actionPath"
           accept="image/jpeg,image/png,image/gif"
           :show-file-list="false"
           :data="postData"
           :before-upload="beforeAvatarUpload"

           :on-success="handleAvatarSuccess"
         >
           <el-button type="primary">本地上传</el-button>
           <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
         </el-upload>
         <el-form-item class="content-center">
           <el-button type="primary" @click="saveTagData">确定保存</el-button>
         </el-form-item>
<!--         <el-input  v-model="form.pics"></el-input>-->
       </el-form>
     </template>
   </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getGoodList,updateItems,createItems,delItems,getCategoryList,delGoods } from'../../../api/jianguan.js'
  import {getUploadQiniuPicToken, uploadQiniuPic} from "../../../api/qiniu";
  // import {onSale,downSale} from "../../../api/baoxian";
  export default {
    data () {
      return {

        isEdit: false,
        tagsList: [],
        id_arr:[],
        cateGoryList:[],
        loading: false,
        total_count: 0,
        actionPath: 'https://up-z1.qiniup.com',
        image_prefix: '',
        type_detail_list:[{
          type_name:'',id:''
        }],
        category_id:[],
        detail_type:'',
        postData: {
          token: '',
          key: '',
          fname: ''
        },
        checked:'',
        pics:'',

        params: {
          page: 1,
          pageSize: 20,
          product_name: '',
        },
        form: {
          tag_id: '',
          product_name: '',
          tag_color: '#ff1939',
          font_color: '#ffffff',
          description: '',
          front_show: '0',
          is_pay: '1',
          type:1,
          intro:'',
          is_online:1,
          exchange_count:'',
          top:'0',
        },

        memberTagDialog: false,
        predefineColors:['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
     type_change(e){

       this.radio = e;
       if (this.radio == "1") {

       } else if (this.radio=='2') {

       }else{

       }
     },
      type_top_change(e){
       this.radio=e;

      },

      getRowKeys(row) {
       return row.id;
      },
      handleSelectionChange(rows) {
        this.id_arr = []

        console.log('before'+this.id_arr )

        if (rows) {
          rows.forEach(row => {
            if (row) {
              this.id_arr.push(row.id)

            }
          })
        }

      },

      beforeAvatarUpload(file) {

        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isGIF = file.type === 'image/gif';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isPNG && !isGIF) {
          this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
          return
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
          return
        }

        this.postData.fname = file.name

        let tokenParams = { filename: file.name, filesystem: 'qiniu' }
        return getUploadQiniuPicToken(tokenParams).then(response => {
          this.postData.token = response.data.data.token
          this.postData.key = response.data.data.key
          this.image_prefix = response.data.data.domain



          this.pics= response.data.data.domain+response.data.data.key

        })
      },
      handleAvatarSuccess(res, file) {

        let uploadParams = {
          image_cat_id: 2,    //图片分类必填,必须为整数
          image_name: file.name,   //图片名称必填,不能超过50个字符
          image_url: res.key,    //图片链接必填
          // image_full_url: res.height,   //图片完整链接必填
          image_type: file.raw.type,   //图片分类长度不能超过20个字符
          storage: 'qiniu',   //图片id必填
        }


        uploadQiniuPic(uploadParams).then(res => {

          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 5 * 1000
          })
          this.isLoadData = false
        })
        // }
      },

      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
        this.form = {id: '',product_name: '',tag: ''}
      },
      editAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      upAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      downAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      getDataList () {
        this.loading = true
        getGoodList(this.params).then(response => {
          this.tagsList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      getCategoryList(){
        this.loading = true
        getCategoryList(this.params).then(response => {
          this.cateGoryList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
          this.category_id=this.cateGoryList[0]
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },

      deleteAction (index, row) {

        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          delItems(row.id).then(response => {

            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime (strDate) {
          let date = new Date(strDate)
          let y = date.getFullYear()
          let m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let str = y+"-"+m+"-"+d
          return str
      },
      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog () {
  			this.memberTagDialog = false
      },
      saveTagData () {
        this.memberTagDialog = false
        //

    //    console.log(this.form);
        if (this.form.id!='') {
          console.log(this.pics)
          if(this.pics!=''){
            this.form.pics= this.pics
          }

          updateItems(this.form.id, this.form).then(res => {

            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.getDataList()
            }
          })
        } else {
          this.form.pics= this.pics
          createItems(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.getDataList()
            }
          })
        }
      },
      delBathGoods(){
// console.log(this.id_arr)
        let form={};
      form={"goods_ids": JSON.stringify(this.id_arr)}
        delGoods(form).then(response =>{
          if (response.status==200) {

            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 5 * 1000
            })
          } else {
            this.$message({
              type: 'error',
              message: '操作失败'
            })
          }
          this.getDataList()
        }).catch(() => {
          //    console.log(row.channelOrderNo)
          this.$message({
            type: 'error',
            message: '操作失败'
          })
        })
      },

      onSale(index, row) {
        this.$confirm('确认操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // console.log(row)
          onSale(row).then(response => {
            // console.log(231)
            // console.log(response)

            if (response.status==200) {

              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 5 * 1000
              })
            } else {
              this.$message({
                type: 'error',
                message: '操作失败'
              })
            }
            this.getDataList()
          }).catch(() => {
        //    console.log(row.channelOrderNo)
            this.$message({
              type: 'error',
              message: '操作失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
    },

    mounted () {
      this.getDataList();
      this.getCategoryList()



// this.category_id= this.cateGoryList[0].id;
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// list.vue?6f09e039